export const ATF = 'atf';
export const BTF = 'btf';
export const CTA = 'cta';
export const VISUAL = 'visual';
export const ELEMENT_KEYS = [ATF, BTF, CTA, VISUAL];

export const AD_WIDTH = '510';
export const AD_HEIGHT = '850';
